import * as Types from './@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetNotificationButtonLinkListQueryVariables = Types.Exact<{
  market: Types.Scalars['String']['input'];
}>;


export type GetNotificationButtonLinkListQuery = { __typename?: 'Query', pushNotificationButtonLinkList: Array<{ __typename?: 'PushNotificationButtonLinkResult', buttonLinkId: string, buttonLinkName: string }> };


export const GetNotificationButtonLinkListDocument = gql`
    query GetNotificationButtonLinkList($market: String!) {
  pushNotificationButtonLinkList(market: $market) {
    buttonLinkId
    buttonLinkName
  }
}
    `;

/**
 * __useGetNotificationButtonLinkListQuery__
 *
 * To run a query within a React component, call `useGetNotificationButtonLinkListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationButtonLinkListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationButtonLinkListQuery({
 *   variables: {
 *      market: // value for 'market'
 *   },
 * });
 */
export function useGetNotificationButtonLinkListQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationButtonLinkListQuery, GetNotificationButtonLinkListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationButtonLinkListQuery, GetNotificationButtonLinkListQueryVariables>(GetNotificationButtonLinkListDocument, options);
      }
export function useGetNotificationButtonLinkListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationButtonLinkListQuery, GetNotificationButtonLinkListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationButtonLinkListQuery, GetNotificationButtonLinkListQueryVariables>(GetNotificationButtonLinkListDocument, options);
        }
export type GetNotificationButtonLinkListQueryHookResult = ReturnType<typeof useGetNotificationButtonLinkListQuery>;
export type GetNotificationButtonLinkListLazyQueryHookResult = ReturnType<typeof useGetNotificationButtonLinkListLazyQuery>;
export type GetNotificationButtonLinkListQueryResult = Apollo.QueryResult<GetNotificationButtonLinkListQuery, GetNotificationButtonLinkListQueryVariables>;